import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';

import styles from './Spinner.module.css';

const Spinner = () => {
  return (
    <div className={styles.wrapper}>
      <LoadingOutlined />
    </div>
  );
};

export default Spinner;
